// Add your custom JS here.
(function ($) {
  // Fade in effects
  AOS.init();

  // Smooth anchor scrolling
  var scroll = new SmoothScroll('a[href*="#"]', {
    speed: 300,
  });

  const swiper = new Swiper(".swiper", {
    // Optional parameters
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 27,
    centeredSlides: false,
    loop: false,
    // If we need pagination
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    //breakpoints
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 27,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 27,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 27,
      },
    },
  });

  if ($(window).width() > 0) {
    $(document).scroll(function () {
      if ($(this).scrollTop() > 50) {
        $("#wrapper-navbar").addClass("off-top");
        $(".sub-menu").addClass("off-top");
      }
      if ($(this).scrollTop() < 50) {
        $("#wrapper-navbar").removeClass("off-top");
        $(".sub-menu").removeClass("off-top");
      }
    });

    //   // // show header based on scroll directions
    //   // var lastScrollTop = 0;
    //   // $(window).scroll(function (event) {
    //   //   var st = $(this).scrollTop();
    //   //   if (st > lastScrollTop) {
    //   //     $("#wrapper-navbar").addClass("show");
    //   //     $(".sub-menu").addClass("show");
    //   //   } else {
    //   //     $("#wrapper-navbar").removeClass("show");
    //   //   }
    //   //   lastScrollTop = st;
    //   // });
  }

  $(".sub-menu").first().wrapInner("<div class='sub-menu-wrapper'></div>");

  // $(".hamburger-wrapper").click(function () {
  //   $(this).toggleClass("active");
  //   $(".mobile-wrapper").toggleClass("active");
  //   $(".button-mobile").toggle().hide();
  // });

  // $("ul .sub-menu").addClass("first-sub-menu");
  // $("ul .sub-menu .sub-menu").addClass("second-sub-menu");

  // $("ul .menu-item-has-children").click(function () {
  //   $("ul .first-sub-menu").toggleClass("active");
  // });

  // $(".arrow-black-menu").click(function () {
  //   $(".second-sub-menu").toggleClass("active");
  // });

  if (window.location.pathname == "/") {
    $("#wrapper-navbar").css("background-color", "transparent");
  } else {
    // Other page
    console.log(window.location.pathname);
  }

  //calculate height of menu

  var height = 60 + $(".sub-menu-wrapper").height();
  $(".sub-menu").first().css("height", height);

  if ($(window).width() > 1200) {
    $(".sub-menu-wrapper").append(
      "<span class='info-menu'><a href='tel:0613339338'>+31 (6) 133 39 338</a><a href='mailto:info@skininstitutedevallei.nl'>info@skininstitutedevallei.nl</a></span>"
    );
  } else {
    $(".navbar-inner").prepend(
      "<span class='info-menu'><a href='tel:0613339338'>+31 (6) 133 39 338</a><a href='mailto:info@skininstitutedevallei.nl'>info@skininstitutedevallei.nl</a></span>"
    );
  }

  $(".tag").each(function () {
    if ($(this).html() == "Nieuws") {
      $(this).addClass("news");
    } else if ($(this).html() == "Blog") {
      $(this).addClass("blog");
    } else {
      $(this).addClass("top10");
    }
  });

  if ($(window).width() > 1200) {
    $(".sub-menu-wrapper")
      .children("li")
      .children("a")
      .on("mouseover", function () {
        $(".sub-menu li").removeClass("active notactive");
        $(this).parent().siblings().addClass("notactive");
        $(this).parent().addClass("active");
        $("#wrapper-navbar").addClass("backactive");
      });

    $("ul.menu")
      .children(".menu-item-has-children")
      .on("mouseover", function () {
        $("#wrapper-navbar").addClass("backactive");
      });

    $(".sub-menu-wrapper").on("mouseleave", function () {
      $(".sub-menu li").removeClass("active notactive");
    });

    $("ul.menu")
      .children(".menu-item-has-children")
      .on("mouseleave", function () {
        $("#wrapper-navbar").removeClass("backactive");
      });
  }

  $(".menu-icon").on("click", function () {
    $("#wrapper-navbar").toggleClass("active");
  });
})(jQuery);
